import { SET_MY_CARS_ENABLED, SET_MY_CARS_SAVED } from '../actions/types';

export function setMyCarsEnabled(enabled) {
	return {
		type: SET_MY_CARS_ENABLED,
		payload: enabled
	};
}

export function setMyCarsSavedVehicles(data) {
	return {
		type: SET_MY_CARS_SAVED,
		payload: [...data]
	};
}
